import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useState, forwardRef } from 'react';
import { faTimeline, faTimes, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useModal from '../../../../../../hooks/useModal';
import { Timestamp } from "firebase/firestore";
import { cn } from '../../../../../../util/cn';
import { updateEmployerAnnualPlan } from '../../../../../../data/employer';
import toast from 'react-hot-toast';
import InfoIcon from '../../../../New_UI/registration/InfoIcon';

const ManageAnnualSubExpiryDate = ({ employerData, subscriptionData }: any) => {
    const { isShowing: showModal, toggle: toggleShowModal } = useModal();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const expiryTimestamp = subscriptionData?.subscriptionExpiry;
    const expiryDate = expiryTimestamp ? convertTimestamp_subAdminNew(employerData?.annualPlan?.startDate) : null;


    const [selectedDate, setSelectedDate] = useState(
        expiryDate ? expiryDate.toDate() : null
    );

    function convertTimestamp_subAdminNew(timestamp: any) {
        if (!timestamp) {
            return null;
        }

        const dateObject = new Date(timestamp.seconds * 1000);
        dateObject.setFullYear(dateObject.getFullYear() + 1);

        return Timestamp.fromDate(dateObject);
    }

    // 👇 Custom input for the DatePicker with calendar icon
    const CustomDateInput = forwardRef(({ value, onClick }: any, ref: any) => (
        <div
            className="flex items-center border border-gray-300 rounded-md px-4 py-2 w-[200px] cursor-pointer bg-white"
            onClick={onClick}
            ref={ref}
        >
            <span className="flex-1 text-sm text-gray-700">{value || 'Select date'}</span>
            <FontAwesomeIcon icon={faCalendarAlt} className="text-gray-500 ml-2" />
        </div>
    ));


    const handleChangingExpiryDate = async () => {
        if (!selectedDate) {
            setError("please select a date");
            return;
        }
        setLoading(true)
        updateEmployerAnnualPlan(employerData?.id, {
            expiryDate: selectedDate,
        }).then((res) => { toggleShowModal(); toast.success(" The expiry date has been updated successfully") })
    }

    return (
        <>
            <div>
                <button
                    className="bg-instant-teams-blue-Main text-white px-8 py-1"
                    onClick={toggleShowModal}
                >
                    Manage Expiry
                </button>
            </div>

            {showModal && (
                <div className="fixed w-full inset-0 xs:p-4 md:p-4 flex items-center no-scrollbar justify-center z-50">
                    <div className="fixed inset-0 bg-black opacity-50" onClick={toggleShowModal}></div>
                    <div className="relative transform transition-transform duration-300 xs:w-full md:w-full ease-in-out bg-white rounded-2xl w-[25vw] shadow-lg p-8">
                        <div className="w-full xs:mt-2 md:mt-2 flex justify-between">
                            <h1 className="text-instant-teams-blue-Main text-xl text-center font-semibold">
                                Manage Expiry
                            </h1>
                            <div
                                className="flex justify-center items-center w-7 h-7 bg-gray-200 rounded-full cursor-pointer"
                                onClick={toggleShowModal}
                            >
                                <FontAwesomeIcon icon={faTimes} color="#565656" />
                            </div>
                        </div>

                        <div className="mt-8 flex flex-col  justify-center items-center w-full">
                            <div>
                                <div className='flex space-x-1' >
                                   <label className="block text-sm mt-[-3px] font-medium text-gray-700 mb-2">
                                    Select Expiry Date
                                    </label>  
                                <InfoIcon tooltipText="You can select any future date beyond the current expiration date" />    
                                </div>
                              
                                <DatePicker
                                    selected={selectedDate}
                                    onChange={(date: any) => setSelectedDate(date)}
                                    minDate={expiryDate ? expiryDate.toDate() : new Date()}
                                    dateFormat="dd MMM yyyy"
                                    customInput={<CustomDateInput />}
                                />
                               {error&& <p className='text-red-600 text-base '>{ error}</p>}
                            </div>
                            <button

                                className={cn(
                                    'h-[50px] mt-10 w-[210px] rounded-[70px] px-5 py-3 text-[16px] bg-[#15415E] text-white leading-[19.6px] font-[400] transition-all duration-200',

                                )}
                                onClick={handleChangingExpiryDate}
                            >
                                {loading ? "Updating Date ..." : "Update"}
                            </button>

                        
                    </div>
                </div>
                </div >
            )}
        </>
    );
};

export default ManageAnnualSubExpiryDate;
